/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class EditFieldModel {

        public hidename: boolean = true;
        public showCondition: boolean = false;
        public systemCodes: Wars.Domain.Model.Codes.CodeGroup[];
        public documentTypes: Wars.Domain.Model.Codes.SystemCode[];
        public scheduledResourceConfigurations: Wars.Domain.Model.ScheduledResourceConfiguration[];
        public paymentConfigurations: Wars.Domain.Model.Payment.PaymentConfiguration[];
        public autoCompleteConfigurations: Wars.Domain.Model.AutoCompleteConfiguration[];
        public apiGridConfigurations: Wars.Domain.Model.ApiGridConfiguration[];
        public objectSchema: Wars.Domain.Model.ObjectSchema;
        public staticDocuments: Wars.Domain.Model.StaticDocument[] = [];
        public isNameProperty: boolean;
        public calculations: Wars.Domain.Model.Calculations.Calculation[];
        public userRepositories: string[];
        public apiAction: Wars.Domain.Model.ApiAction;
        public systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        public documentConfigurations: Wars.Domain.Model.Documents.DocumentConfiguration[];
        public codeToExclude: Wars.Domain.Model.Codes.SystemCode;
        public statusToExclude: Wars.Domain.Model.Statuses.StatusCode;
        public stateToExclude: Wars.Domain.Model.Statuses.StateCode;
        public processTypeToExclude: Wars.Domain.Model.ProcessType;
        public processTypes: Wars.Domain.Model.ProcessType[];
        public mapConfigurations:Wars.Domain.Model.Gis.MapConfiguration[];
        public mapOverrides:Wars.Domain.Model.Gis.MapConfigurationOverride[];
        public statusCodes: Wars.Domain.Model.Statuses.StatusCode[];
        public stateCodes: Wars.Domain.Model.Statuses.StateCode[];

        constructor(
            public field: Wars.Domain.Model.Field,
            private service: services.ProcessConfigurationService,
            private manageCodeService: services.ManageSystemCodesService,
            private systemLevelService: services.SystemLevelService,
            private processTypeService: services.ProcessTypeService,
            public processConfigId: string,
            public formSection: Wars.Domain.Model.FormSection,
            private treeService: services.TreeService,
            private manageScheduledResourcesService: services.ManageScheduledResourcesService,
            private objectSchemaService: services.ObjectSchemaService,
            private manageStaticDocumentsService: services.ManageStaticDocumentsService,
            private autoCompleteService: services.AutoCompleteConfigurationService,
            private processConfiguration: Wars.Domain.Model.ProcessConfiguration,
            private apiGridConfigurationService: services.ApiGridConfigurationService,
            private calculationService: services.CalculationService,
            private reviewConfigurationService: services.ReviewConfigurationService,
            private apiActionService: services.ApiActionService,
            private securityMatrixService: services.SecurityMatrixService,
            private documentService: services.DocumentService,
            private form: Wars.Domain.Model.Form,
            private fieldService: services.FieldService,
            private growl: angular.growl.IGrowlService,
            private processActionService: services.ProcessActionService,
            private mapConfigurationService: services.MapConfigurationService,
            private mapOverridesService: services.MapConfigurationOverridesService)
        {
            var self = this;

            this.loadProcessTypes();

            if (this.field.maxTextLength == null || this.field.maxTextLength === 0 || this.field.maxTextLength > 4000) {
                this.field.maxTextLength = 4000;
            }

            if (this.field.textAreaRows == null || this.field.textAreaRows < 5 || this.field.textAreaRows > 20) {
                this.field.textAreaRows = 5;
            }

            if (form && form.defaultFormValueApiActionUniqueId) {
                apiActionService.getApiActionForField(form.defaultFormValueApiActionUniqueId).then(r => {
                    this.apiAction = r[0];
                });
            }

            this.mapOverridesService.getMapConfigurationOverrides(this.processConfigId).then(o => {
                this.mapOverrides = o;
            });

            this.processActionService.getAllProcessActions(this.processConfigId).then(processActions => {
                this.processActions = processActions;
            });

            mapConfigurationService.getMapConfigurations().then(m => {
                this.mapConfigurations = m;
            });

            this.documentConfigurations = [];
            this.systemLevelService.getSystemLevelDocumentConfiguration().then(
                (sysLevel) => {
                    this.systemDocumentConfiguration = sysLevel.systemDocumentConfiguration;
                    this.documentConfigurations = this.documentConfigurations.concat(sysLevel.myDocumentConfigurations);
                });

            this.documentService.getDocumentConfigs(this.processConfigId).then(
                (docConfigs) => {
                    this.documentConfigurations = this.documentConfigurations.concat(docConfigs);
                });

            this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    this.systemCodes = systemLevel.myCodeGroups;
                    this.manageCodeService.getAllCodesForProcessConfiguration(this.processConfigId).then(
                        (codeGroups) => {
                            this.systemCodes = this.systemCodes.concat(codeGroups);
                        });
                });

            this.systemLevelService.getSystemLevelStaticDocuments().then(
                (systemLevel) => {
                    this.staticDocuments = systemLevel.myStaticDocuments;
                    manageStaticDocumentsService.getStaticDocumentsForProcessConfiguration(this.processConfigId)
                        .then(d => {
                            d.forEach(doc => {
                                this.staticDocuments.push(doc);
                            });
                        });
                });

            this.statusCodes = [];
            this.stateCodes = [];
            this.systemLevelService.getSystemLevelStatusesAndStates().then((systemLevel) => {
                systemLevel.statusCodeGroup.myStatuses.forEach(statusCode => {
                    this.statusCodes.push(statusCode)

                    statusCode.myStates.forEach(stateCode => {
                        this.stateCodes.push(stateCode);
                    });
                });
            });

            this.autoCompleteService.getAutoCompleteConfigurations(processConfigId).then(r => {
                this.autoCompleteConfigurations = r;
            });

            this.reviewConfigurationService.getExtensibleUserRepositories().then(repos => {
                this.userRepositories = repos;
            });

            if (formSection.objectSchema.isList && formSection.systemLevelListSchemaProperty_id) {
                //console.log("list");
                self.objectSchemaService.getObjectSchemaExpanded(formSection.systemLevelListSchemaProperty.typeSchema.id)
                    .then(
                        (objectSchema) => {
                            self.objectSchema = formSection.systemLevelListSchemaProperty.typeSchema;
                        });
            } else {
                this.systemLevelService.getSystemLevel()
                    .then((systemLevel) => {
                        //console.log("not list");
                        self.objectSchemaService.getObjectSchemaExpanded(systemLevel.variableSchema_id)
                            .then(
                                (objectSchema) => {
                                    self.objectSchema = objectSchema;
                                });
                    });
            }

            this.apiGridConfigurationService.getApiGridConfigurations(processConfigId).then(configs => {
                this.apiGridConfigurations = configs;
            });

            this.calculationService.getAllCalculations(this.processConfigId).then(calcs => {
                this.calculations = calcs;
            });

            service.getProcessConfigurationEagerEditFormParameters(processConfigId).then(processConfig => {
                self.processConfiguration = processConfig;
                this.paymentConfigurations = processConfig.myPaymentConfigurations;
                systemLevelService.getSystemLevelPaymentInfo().then(
                    (systemLevel) => {
                        this.paymentConfigurations = this.paymentConfigurations.concat(systemLevel.myPaymentConfigurations);
                    });
            });

            manageScheduledResourcesService
                .getAllScheduledResourcesForProcessConfigurationAndSystem(processConfigId)
                .then(s => {
                    self.scheduledResourceConfigurations = s;
                });

            service.loadFieldGroup(field);
            service.loadFieldExcludes(field);

            if (processConfiguration) {
                this.isNameProperty = this.processConfiguration.nameSchemaProperty_id == field.schemaProperty.id;
            }
            //field.entityAspect.loadNavigationProperty('systemCodeGroup').then(t => {}); 
        }

        public getNonExcludedStateCodes() {
            if (!this.field.fieldExcludedStates || this.field.fieldExcludedStates.length === 0) {
                return this.stateCodes;
            }
            var codes = [];
            if (this.stateCodes && this.stateCodes.length) {
                for (var i = 0; i < this.stateCodes.length; i++) {
                    if (Enumerable.from(this.field
                        .fieldExcludedStates)
                        .any(x => x.stateCode_id === this.stateCodes[i].id)) {
                        continue;
                    }
                    codes.push(this.stateCodes[i]);
                }    
            }
            return codes;
        }

        public fieldTypeChanged() {
            this.treeService.getVariableTypeForField(this.field).then(type => {
                this.field.schemaProperty.propertyType = type;
            });
            if (this.field.type === Wars.Domain.Model.Codes.Enums.FieldType.StateChange) {
                if (this.field.changeStateButtonText === null || this.field.changeStateButtonText === undefined) {
                    this.field.changeStateButtonText = "Change State";
                }
            }
            (<any>this.field).fieldTypeChanged = true;
        }

        public applySecurityMatrixChanged(): void {
            if (this.field.applySecurityMatrix && !this.field.securityMatrix) {
                this.field.securityMatrix = this.securityMatrixService.createAdvancedSecurityMatrix(false, false);
            }
        }

        public applyDefaultSecurityMatrixChanged(): void {
            if (this.field.applyDefaultValueSecurityMatrix && !this.field.defaultValueSecurityMatrix) {
                this.field.defaultValueSecurityMatrix = this.securityMatrixService.createSecurityMatrix(false);
            }
        }

        public isNamePropertyChanged() {
            if (this.isNameProperty) {
                this.processConfiguration.nameSchemaProperty_id = this.field.schemaProperty.id;
                this.processConfiguration.nameFormUniqueId = this.form.uniqueIdentifier;
            } else {
                this.processConfiguration.nameSchemaProperty_id = null;
                this.processConfiguration.nameFormUniqueId = null;
            }
        }

        public systemVariableChanged() {

            if (this.field.type === 3 || this.field.type === 10) {
                if (this.field.schemaProperty.systemVariable) {
                    this.field.schemaProperty.codeGroup = this.field.schemaProperty.systemVariable.codeGroup;
                } else {
                    this.field.schemaProperty.codeGroup = null;
                }
            }
        }

        public addOption() {
            if (this.field.schemaProperty.codeGroup == null || this.field.schemaProperty.codeGroup.systemLevel_id) {
                const newCodeGroup = this.manageCodeService.createNewSpecializedCodeGroup();
                this.field.schemaProperty.codeGroup = newCodeGroup;
            }

            const newCode = this.manageCodeService.createNewSystemCode(this.field.schemaProperty.codeGroup, false);
            newCode.isActive = true;

            this.field.schemaProperty.codeGroup.codes.push(newCode);
        }

        public removeOption(code: Wars.Domain.Model.Codes.SystemCode) {
            code.entityAspect.setDeleted();
            //var index = Enumerable.from(this.field.fieldCodeGroup[0].codes).indexOf(c => c.id == code.id);
            //this.field.fieldCodeGroup[0].codes.splice(index, 1);
        }

        public isIndexedChanged() {
            if (!this.field.schemaProperty.isIndexed) {
                this.field.schemaProperty.systemVariable = null;
            }
        }

        public removeExcludedSystemCode(item: Wars.Domain.Model.FieldExcludedSystemCodes) {
            item.entityAspect.setDeleted();
        }

        public removeExcludedStatus(item: Wars.Domain.Model.FieldExcludedStatuses) {
            item.entityAspect.setDeleted();
        }

        public removeExcludedState(item: Wars.Domain.Model.FieldExcludedStates) {
            item.entityAspect.setDeleted();
        }

        public removeExcludedProcessType(item: Wars.Domain.Model.FieldExcludedProcessTypes) {
            item.entityAspect.setDeleted();
        }

        public loadProcessTypes() {
            var self = this;
            self.processTypeService.getAllProcessTypes()
                .then((processTypes) => {
                    self.processTypes = Enumerable.from(processTypes)
                        .where(i => !i.isReportProcess && !i.isSingleInstanceProcess)
                        .distinct()
                        .toArray();
                });
        }

        public addExcludedStatus() {
            if (Enumerable.from(this.field.fieldExcludedStatuses).any(c => c.statusCode_id=== this.statusToExclude.id)) {
                this.growl.error("This status has already been added to the exclude list");
                return;
            }

            const excludedStatus = this.fieldService.createFieldExcludedStatuses();
            excludedStatus.field = this.field;
            excludedStatus.statusCode = this.statusToExclude;

            this.field.fieldExcludedStatuses.push(excludedStatus);
        }

        public addExcludedState() {
            if (Enumerable.from(this.field.fieldExcludedStates).any(c => c.stateCode_id=== this.stateToExclude.id)) {
                this.growl.error("This state has already been added to the exclude list");
                return;
            }

            const excludedState = this.fieldService.createFieldExcludedStates();
            excludedState.field = this.field;
            excludedState.stateCode = this.stateToExclude;

            this.field.fieldExcludedStates.push(excludedState);
        }

        public addExcludedSystemCode() {
            if (Enumerable.from(this.field.fieldExcludedSystemCodes).any(c => c.systemCode_id === this.codeToExclude.id)) {
                this.growl.error("This code has already been added to the exclude list");
                return;
            }

            const excludedCode = this.fieldService.createFieldExcludedSystemCodes();
            excludedCode.field = this.field;
            excludedCode.systemCode = this.codeToExclude;

            this.field.fieldExcludedSystemCodes.push(excludedCode);
        }

        public addExcludedProcessType() {
            if (Enumerable.from(this.field.fieldExcludedProcessTypes).any(c => c.processType_id === this.processTypeToExclude.id)) {
                this.growl.error("This process type has already been added to the exclude list");
                return;
            }

            const excludedProcessType = this.fieldService.createFieldExcludedProcessTypes();
            excludedProcessType.field = this.field;
            excludedProcessType.processType = this.processTypeToExclude;

            this.field.fieldExcludedProcessTypes.push(excludedProcessType);
 
        }

        public processActions: Wars.Domain.Model.ProcessAction[];
    }
}